import React from 'react';
// @ts-ignore
import { UchiruLogo } from '@front/ui-uchi';
import TitleHeader from 'features/shared/ui/TitleHeader';
import Logout from 'features/shared/Logout';
import { AuthEntryButton, HeaderFixed, HeaderInner, HeaderWrap, LogoLink, LogoutWrapper } from './styled';

import { Space } from '@gr-monorepo/common/ui';
import { useClickStreamContext } from 'features/shared/ClickStream';
import { useAuthContext } from 'hooks/useAuthContext';
import { useLoginModal } from 'features/shared/Login/LoginModalContext';

const Header = () => {
  const { authorized } = useAuthContext();
  const { logPageEvent } = useClickStreamContext();
  const { openLoginModal } = useLoginModal();

  return (
    <HeaderWrap data-testid="main-header">
      <HeaderFixed>
        <HeaderInner>
          <LogoLink to="/" aria-label="Учи.ру">
            <UchiruLogo theme="primary" />
          </LogoLink>
          {authorized ? <TitleHeader /> : null}
          <Space />
          <LogoutWrapper>
            {authorized ? (
              <Logout />
            ) : (
              <AuthEntryButton
                type="button"
                onClick={() => {
                  logPageEvent({
                    eventType: 'click',
                    eventInfo: 'unauth_header_click_entrance',
                  });
                  openLoginModal();
                }}
                data-qa-id="button_login2"
                data-testid="header-login-button"
              >
                Вход / регистрация
              </AuthEntryButton>
            )}
          </LogoutWrapper>
        </HeaderInner>
      </HeaderFixed>
    </HeaderWrap>
  );
};

export default Header;
